import { StateCreator } from "zustand";
import { IAppState } from "./types";

const clearStore: StateCreator<
    IAppState,
    [["zustand/devtools", never], ["zustand/persist", unknown], ["zustand/immer", never]],
    [],
    {
        clearStore: () => void;
    }
    > = (set) => {
    return {
        clearStore: () => {
            set(state => {
                state.auth.token = null;
                state.auth.email = '';
                state.auth.expiresIn = null;
                state.auth.phoneNumber = '';
                state.auth.roleName = '';
                state.auth.name = '';
                state.auth.profilePicture = '';
            })
        }
    }
};

export default clearStore;